<section class="vh100">
    <div class="cw" fxLayout="column">

        <div fxLayoutAlign="center" class="fw">
            <mat-icon class="ftxxxl gray-4 linkIcon centertext"> question_answer</mat-icon>
        </div>

        <h6 class="h6Title centertext"> FAQ </h6>

        <h6 class="h6Title"> ¿Qué es Predyc?</h6>
        <p>Predyc es una plataforma de capacitación para el sector industrial que reúne a instructores y empresas para
            presentar conocimientos técnicos para todas las áreas de la Ingenieria. Esta es una versión BETA que podría
            contener cambios que afecten tu experiencia de usuario en el alguna oportunidad, el equipo de Predyc estará para poyarte si tienes algún inconveniente. </p>
        <h6 class="h6Title">¿Cuál es la modalidad de estudios en Predyc?</h6>
        <p>Todo nuestro contenido es 100% en línea, son clases pregrabadas a las que tendrás acceso de por vida una vez
            realices tu inscripción a algún tema. Podrás iniciarlos y terminarlo a tu ritmo.</p>

        <h6 class="h6Title">¿Cómo realizo la compra de un curso?</h6>
        <p>Para comprar un curso entra al tema que te interesa y da clic en inscribirse, sigue los pasos del proceso de
            compra y una vez confirmada tendrás acceso a tu curso.</p>

        <h6 class="h6Title">¿Cómo son los métodos de pago?</h6>
        <p>Puedes realizar tus compras a través de tarjeta de débito y crédito mediante nuestra plataforma de cobro.</p>

        <h6 class="h6Title">¿Puedo realizar el pago con una tarjeta de moneda diferente a la que se muestran en los
            cursos?</h6>
        <p>Así es, puedes realizar tu compra con la tarjeta de débito y crédito de tu moneda nacional sin ningún
            inconveniente.</p>

        <h6 class="h6Title">¿Cómo puedo descargar el comprobante de mis compras realizadas?</h6>

        <p>Para descargar el comprobante de pago de las compras de tu curso, entrando en tu cuenta/ historial de
            compras. haz clic dentro de la compra y luego en descargar invoice.</p>
        <h6 class="h6Title">¿Cómo me registro para ser instructor de Predyc?</h6>

        <p>Si ya tienes un curso pregrabado y quieres presentarlo dentro de Predyc ve a la sección enseña en Predyc y
            rellena el formulario con tu información y un representante se pondrá en contacto para ayudarte en todos los
            pasos siguientes.</p>
        <h6 class="h6Title">¿Tengo que pagar alguna tarifa para convertirme en instructor?</h6>
        <p>No, presentar un curso dentro de la Predyc no tiene costo, recibirás tus ganancias en función de un reparto
            de utilidades de las ventas generadas de tus cursos.</p>
        <h6 class="h6Title">¿Predyc toma los derechos de autor o contenido sobre mi curso una vez que lo ofrezco en la
            plataforma?</h6>
        <p>No, cuando publicas un curso en nuestra plataforma mantienes todos los derechos sobre el contenido.
            Simplemente, nos concedes un permiso para alojar el curso, ponerlo a la venta para nuestros usuarios y
            anunciarlo en nuestra plataforma.</p>
        <h6 class="h6Title">¿Cómo puedo contactar a Predyc?</h6>
        <p>Puedes ponerte en contacto con nosotros a través del chat en línea en el botón situado en la parte inferior
            derecha o escríbenos al correo: contacto@predyc.com</p>
        <h6 class="h6Title">¿Cómo puedo tener un reembolso de mi compra?</h6>
        <p>Si deseas realizar el reembolso de un curso, deberes notificar justificando el motivo de reembolso dentro de
            los primeros 7 días naturales en realizar tu compra y este no deberá tener un avance mayor al 20% de su
            progreso. Contacta con nosotros mediante el chat en línea o escríbenos al correo: contacto@predyc.com
            Predyc es una plataforma en proceso de desarrollo y actualización, seguimos mejorando para darte la mejor
            experiencia como estudiante e instructor.
        </p>



    </div>
</section>